export default {
  en: {
    title: "Reports",
    no_data: "No data available",
    filters: {
      from: "From",
      to: "To",
      date: "Date",
      report_type: "Report Type",
      duration: "Duration",
      duration_placeholder: "Set Call Duration limit",
      call_type: "Call Type",
      select_agent: "Agent",
      hung_party: "Hungup Party",
      number: "Number",
      select_skill: "Queue",
      select_period: "Period",
      select_status: "Status",
      get: "GET",
      export: "EXPORT",
      incoming: "incoming",
      outgoing: "outgoing",
      internal: "internal",
      agent: "Agent",
      caller: "Customer",
      hours: "Hours",
      half_hours: "Half Hours",
      days: "Days",
      all: "All",
      active: "Active",
      rating_type: "Rating Type",
      rating_type_1: "FCR Question",
      rating_type_2: "Agent Performance",
      rating_type_3: "Customer Effort",
      rating_type_4: "CSAT Question",
      rating_type_5: "All Questions",
      invalid_date: "Invalid date value",
      date_missing: "date is required",
      end_bigger_than_start: "date must bigger than the start date",
      start_less_than_end: "date must less than the end date",
      reset: "Reset Filters",
      quick_dates: "Quick Date Ranges",
      presets: {
        today: "Today",
        yesterday: "Yesterday",
        last_7_days: "Last 7 Days",
        last_30_days: "Last 30 Days",
        this_month: "This Month",
        last_month: "Last Month"
      },
      csat_table_report: "CSAT Table Report",
      select_campaign: "Campaign",
      disposition: "Disposition",
      disposition_answered: "Answered",
      disposition_busy: "Busy",
      disposition_no_answer: "No Answer",
      disposition_canceled: "Canceled",
      disposition_failed: "Failed",
      voice_agent_cdr: "Voice Agent CDR",
      ai_chat_transcript: "AI Chat Transcripts"
    },
    calls_report: {
      calls_count: "{n} call | {n} calls",
      title: "CDRs",
      recording_title: "Call recording",
      head_id: "ID",
      head_date: "Date",
      head_src: "SRC",
      head_number: "Number",
      head_dst: "DST",
      head_agent: "Agent",
      head_call_type: "Call Type",
      head_dstchannel: "DSTchannel",
      head_queue: "Queue",
      head_duration: "Duration",
      head_status: "Status",
      head_dtmf: "DTMF",
      head_hungparty: "Hungup Party",
      head_reason: "Reason",
      head_listen: "Listen",
      head_download: "Download",
      listen_btn: "Listen",
      hide_audio_btn: "Close",
      download_btn: "Downlaod",
      calltype_incoming: "INCOMING",
      calltype_outgoing: "OUTGOING",
      calltype_internal: "INTERNAL",
      calltype_dial: "DIAL",
      UNANSWERED: "UNANSWERED",
      ANSWERED: "ANSWERED",
      DROP: "DROP",
      head_sa: "Speed of Answer",
      head_wait: "Wait Time",
    },
    total_performance_report: {
      title: "Total Queues Performance",
      head_skill: "Queue",
      head_total: "Total",
      head_playback: "IVR & Playback",
      head_offered: "Offered",
      head_success: "Success",
      head_success_rate: "Success Rate",
      head_failed: "Failed",
      head_failed_rate: "Failed Rate",
    },
    performance_period_report: {
      title: "Calls per Period Performance",
      head_period: "Period",
      head_offered: "OFF",
      head_answered: "ANS",
      head_abandoned: "ABD",
      head_answered_rate: "ASA",
      head_service_level: "ANS SL%",
      head_average_talk_time: "AVG Talk",
      head_average_hold_time: "AVG Hold",
      head_average_handle_time: "AVG Hand",
      head_hold_count: "Hold",
      summary: "Summary",
    },
    agent_performance_report: {
      agents_count: "{n} agent | {n} agents",
      title: "Agent Overall Performance",
      head_agent: "Agent",
      head_name: "Name",
      head_received_calls: "Received",
      head_answered_calls: "Answered",
      head_answered_rate: "Answered Rate",
      head_abandoned_calls: "Abandoned",
      head_avg_duration: "Average Duration ",
      head_min_duration: "MIN Duration",
      head_max_duration: "MAX Duration",
    },
    agent_calls_report: {
      calls_count: "{n} call | {n} calls",
      title: "Calls Records",
      head_date: "Date",
      head_src: "MDN",
      head_call_type: "Call Type",
      head_duration: "Duration",
      head_reason: "Reason",
      calltype_incoming: "INCOMING",
      calltype_outgoing: "OUTGOING",
      calltype_internal: "INTERNAL",
      calltype_dial: "DIAL",
      no_calls: "No calls found",
    },
    agent_status_report: {
      my_statuses: "My Statuses",
      status_count: "{n} status",
      title: "Agent Status Statistics",
      online_time: "Online Time",
      busy_time: "Busy Time",
      rest_time: "Rest Time",
      available_time: "Available Time",
      head_time: "Time",
      head_date: "Date",
      head_action: "Action",
      head_duration: "Duration",
      status_online: "Online",
      status_busy: "Not Ready",
      status_rest: "Resting",
      status_offline: "Offline",
      no_statuses: "No statuses",
    },
    system_inbound_report: {
      title: "System Inbound Report",
      calls_count: "{n} call | {n} calls",
      date: "Date",
      head_Inbound: "Inbound Calls",
      head_Successful: "Successful Calls ",
      head_Rate: "IVR &  Successful Rate % ",
      head_LostCall: "Lost Calls",
    },
    leaving_detail_report: {
      title: "Agent Leaving Report in Detail",
      employee_count: "{n} Employee | {n} Employees",
      head_ID: "Agent ID",
      head_Name: "Agent Name",
      head_LeavingTime: "Request Leaving Time ",
      head_LeavingDuration: "Request Leaving Duration",
      head_StartTime: "Leaving Start Time",
      head_EndTime: "Leaving End Time",
      head_ActualDuration: "Actual Leaving Duration",
      head_ExtraDuration: "Extra Leaving Duration",
      leaving_count: "{n} leaving | {n} leaving",
    },
    leaving_summary_report: {
      title: "Agent Leaving Report in Summary",
      head_ID: "Agent ID",
      head_Name: "Agent Name",
      head_LeavingNumber: "Number of Request Leaving ",
      head_LeavingDuration: " Leaving Duration",
      head_ExtraDuration: "Extra Leaving Duration",
      head_ExtraNumberLeaving: "Number of Extra Leaving",
    },
    login_detail_report: {
      title: "Login/Logout Report in Detail",
      log: "Log",
      head_ID: "Agent ID",
      head_Name: "Agent Name",
      head_Login: "Login ",
      head_Logout: "Logout",
      head_Staffed: "Staffed Duration",
    },
    login_summary_report: {
      title: "Login/Logout Report in Summary",
      head_ID: "Agent ID",
      head_Name: "Agent Name",
      head_Login: "Login ",
      head_Logout: "Logout",
      head_Staffed: "Staffed Duration",
    },
    status_detail_report: {
      title: "Status Of Agent in Detail",
      head_ID: "Agent ID",
      head_Name: "Agent Name",
      head_Status: "Status",
      head_BeginTime: "Status Begin Time",
      head_EndTime: "Status End Time",
      head_Duration: "Status Duration",
    },
    status_summary_report: {
      title: "Status Of Agent in Summary",
      head_Name: "Agent Name",
      head_online_periods: "Online Periods",
      head_offline_periods: "Offline Periods",
      head_rest_periods: "Resting Periods",
      head_not_ready_periods: "Not Ready Periods",
      head_online_duration: "Online Duration",
      head_offline_duration: "Offline Duration",
      head_rest_duration: "Resting Duration",
      head_not_ready_duration: "Not Ready Duration",
    },
    agent_kpi_report: {
      title: "Agent Key Performance Indicators",
      head_day: "Day",
      head_offered: "OFF",
      head_answered: "ANS",
      head_abandoned: "ABD",
      head_average_handle_time: "AHT",
      head_utilization: "Utilization",
      head_occupancy: "Occupancy",
      head_agent_behavior: "Agent Behavior",
      head_fcr: "FCR",
      head_very_satisfied: "Very Satisfied",
      head_satisfied: "Satisfied",
      head_neutral: "Neutral",
      head_dissatisfied: "Dissatisfied",
      head_very_dissatisfied: "Very Dissatisfied",
      head_yes: "Yes",
      head_no: "No",
    },
    pagination: {
      records_per_page: "Records per page",
      rows_per_page: "Rows per page",
      showing: "Showing",
      of: "of",
      page: "Page",
      records: "records",
      first_page: "First page",
      previous_page: "Previous page",
      next_page: "Next page",
      last_page: "Last page",
      jump_to: "Jump to page",
      go: "Go",
    },
    loading: {
      default: "Loading report data...",
      initial: "Loading initial data...",
      processing: "Processing...",
      general: "Loading..."
    },
    empty: {
      title: "No Data Found",
      description: "No data matches your current filters. Try adjusting your search criteria or refresh to try again.",
      refresh: "Refresh Data"
    },
    error: {
      title: "Error Loading Report",
      retry: "Retry",
      dismiss: "Dismiss",
      close: "Close"
    },


    csat_report: {
      title: "CSAT Chart Report",
      all_entered_surveys: "All Entered Surveys",
      completed_surveys: "Completed Surveys",
      uncompleted_surveys: "Uncompleted Surveys",
      very_dissatisfied: "Very Dissatisfied",
      dissatisfied: "Dissatisfied",
      neutral: "Neutral",
      satisfied: "Satisfied",
      very_satisfied: "Very Satisfied",
      fcr_question: "Has your  request been executed resolved during your interaction today?",
      agent_performance_question: "How satisfied are you with the performance of the agent who assisted you today?",
      customer_effort_question: "How easy did GO make it for you to handle your request?",
      csat_question: "How satisfied are you with your recent interaction with GO contact center?",
      agent_name: "Agent",
      yes: "Yes",
      no: "No",
      month: "Month",
      neutural: "Neutural",
      promoters: "Promoters",
      passives: "Passives",
      detractors: "Detractors",
      nps_question: "NPS Question",
      report_variant: "Report Variant",
      per_agent: "Per Agent",
      per_month: "Per Month",
      per_call: "Per Call",
      show_tables: "Show Tables",
      show_charts: "Show Charts",
    },
    csat_table_report: {
      title: "CSAT Table Report",
    },
    repeated_calls_report: {
      title: "Repeated Calls Report",
      head_month: "Month",
      head_repeated_calls: "Repeated Calls",
    },
    call_reasons_report: {
      title: "Call Reasons Report",
      complaint: "Complaint",
      request: "Request",
      inquiry: "Inquiry",
      not_selected: "Not Selected",
      go_to_table: "Go to Call Reason Table",
      export_tooltip: "Click to export this reason",
      no_data: "No data available",
    },
    ivr_report: {
      title: "IVR Report",
      no_data: "No IVR data available",
    },
    ivr_campaign_summary_report: {
      title: "IVR Campaign Summary & Calls",
      summary_title: "Summary",
      calls_title: "Calls",
      head_total_calls: "Total Calls",
      head_answered: "Answered",
      head_unanswered: "Unanswered",
      head_success_rate: "Success Rate",
      head_campaign: "Campaign",
      head_customer: "Customer",
      head_disposition: "Disposition",
      head_retry: "Retries",
      head_invoice: "Invoice",
      head_date: "Date",
      no_data: "No campaign data for the selected range",
      dispositions: {
        answered: "Answered",
        busy: "Busy",
        no_answer: "No Answer",
        canceled: "Canceled",
        failed: "Failed",
      },
    },
    call_analysis: {
      back: "Back",
      title: "Call Analysis",
      action_tooltip: "View call analysis",
      not_found: "No analysis available for this call.",
      loading: "Loading analysis...",
      head_call_id: "Call ID",
      head_number: "Number",
      head_agent: "Agent",
      head_date: "Date",
      load_recording: "Load recording",
      qa_score: "QA Score",
      qa_checks_passed: "Checks passed",
      qa_required_failure: "Required check failed",
      qa_no_failures: "No required failures",
      qa_section_title: "QA Evaluation",
      required: "Required",
      optional: "Optional",
      confidence: "Confidence",
      evidence: "Evidence",
      reasoning: "Reasoning",
      customer_sentiment: "Customer Sentiment",
      agent_sentiment: "Agent Sentiment",
      magnitude: "Magnitude",
      score: "Score",
      positive: "Positive",
      neutral: "Neutral",
      negative: "Negative",
      timeline_title: "Sentiment Timeline",
      summary_section_title: "Summary",
      transcript_section_title: "Transcript",
      no_transcript: "No transcript available for this call.",
      role_agent: "Agent",
      role_customer: "Customer"
    },
    voice_agent_cdr: {
      title: "Voice Agent CDR",
      head_call_id: "Call ID",
      head_caller: "Caller",
      head_dialed: "Dialed",
      head_duration: "Duration",
      head_started: "Started At",
      head_ended: "Ended At",
      head_forwarded: "Forwarded",
      view_details: "View details",
      forwarded_yes: "Yes",
      forwarded_no: "No",
      stat_total_calls: "Total Calls",
      stat_avg_duration: "Avg Duration",
      details_title: "Voice Call Details",
      meta_room: "Room",
      meta_recording: "Recording",
      transcript_title: "Transcript",
      no_transcript: "No transcript available for this call.",
      role_assistant: "AI Agent",
      role_user: "Caller",
      no_data: "No details available.",
      loading: "Loading details...",
      back: "Back",
      not_found: "No details available for this call.",
      load_recording: "Load recording",
      recording_unavailable: "Recording unavailable",
      summary_title: "Summary",
      tags_title: "Tags",
      head_tags: "Tags"
    },
    ai_chat_transcript: {
      title: "AI Chat Transcripts",
      head_conversation_id: "Conversation ID",
      head_customer: "Customer",
      head_channel: "Channel",
      head_outcome: "Outcome",
      head_started: "Started At",
      head_ended: "Ended At",
      view_transcript: "View transcript",
      stat_total_chats: "Total Chats",
      stat_avg_duration: "Avg Duration",
      stat_escalation_rate: "Escalation Rate",
      details_title: "Chat Conversation",
      back: "Back",
      tags_title: "Tags",
      meta_customer: "Customer",
      meta_channel: "Channel",
      meta_agent: "Agent",
      meta_outcome: "Outcome",
      meta_started: "Started At",
      meta_ended: "Ended At",
      summary_title: "Summary",
      transcript_title: "Transcript",
      no_transcript: "No messages in this conversation.",
      no_data: "No conversation details available.",
      loading: "Loading conversation...",
      role_customer: "Customer",
      role_assistant: "AI Assistant",
      role_agent: "Agent",
      channels: {
        1: "SMS",
        2: "Email",
        3: "WhatsApp",
        4: "Telegram",
        5: "Facebook",
        6: "Instagram",
        7: "Twitter/X",
        8: "Web Chat",
        default: "Channel"
      },
      outcomes: {
        abandoned: "Abandoned",
        escalated: "Escalated",
        resolved: "Resolved",
        completed: "Completed",
        closed: "Closed"
      }
    },
  },
  ar: {
    title: "التقارير",
    no_data: "لا توجد بيانات متاحة",
    filters: {
      from: "من",
      to: "إلى",
      date: "التاريخ",
      duration: "المدة",
      report_type: "نوع التقرير",
      duration_placeholder: "تحديد أعلى مدة",
      call_type: "نوع المكالمة",
      select_agent: "الموظف",
      hung_party: "جهة إغلاق الخط",
      number: "الهاتف",
      select_skill: "المجموعة",
      select_period: "الفترة",
      select_status: "الحالة",
      get: "عرض",
      export: "تصدير",
      incoming: "واردة",
      outgoing: "صادرة",
      internal: "داخلية",
      agent: "موظف",
      caller: "عميل",
      hours: "ساعات",
      half_hours: "نص ساعة",
      days: "أيام",
      all: "الكل",
      active: "نشط",
      rating_type: "نوع التقييم",
      rating_type_1: "سؤال FCR",
      rating_type_2: "أداء الموظف",
      rating_type_3: "جهد العميل",
      rating_type_4: "سؤال CSAT",
      rating_type_5: "جميع الأسئلة",
      invalid_date: "قيمة تاريخ خاطئة",
      date_missing: "قيمة تاريخ مطلوبة",
      end_bigger_than_start: "تاريخ البدأ أكبر من الإنتهاء",
      start_less_than_end: "تاريخ الإنتهاء أصغر من الإبتداء",
      reset: "إعادة تعيين المرشحات",
      quick_dates: "نطاقات التاريخ السريعة",
      presets: {
        today: "اليوم",
        yesterday: "أمس",
        last_7_days: "آخر 7 أيام",
        last_30_days: "آخر 30 يوم",
        this_month: "هذا الشهر",
        last_month: "الشهر الماضي"
      },
      csat_table_report: "تقرير جداول الرضا",
      select_campaign: "الحملة",
      disposition: "النتيجة",
      disposition_answered: "تم الرد",
      disposition_busy: "مشغول",
      disposition_no_answer: "بدون رد",
      disposition_canceled: "ملغاة",
      disposition_failed: "فشلت",
      voice_agent_cdr: "سجل مكالمات الوكيل الصوتي",
      ai_chat_transcript: "محادثات الوكيل الذكي"
    },
    calls_report: {
      calls_count:
        "{n} مكالمة | مكالمة واحدة | مكالمتان | {n} مكالمات | {n} مكالمة | {n} مكالمة",
      title: "سجلّات المكالمات",
      recording_title: "تسجيل المكالمة",
      head_id: "معرّف المكالمة",
      head_date: "التاريخ",
      head_src: "المصدر",
      head_number: "الهاتف",
      head_dst: "الجهة",
      head_agent: "الموظف",
      head_call_type: "نوع المكالمة",
      head_dstchannel: "معرّف ممر المكالمة",
      head_queue: "المجموعة",
      head_duration: "المدة",
      head_status: "الحالة",
      head_dtmf: "DTMF",
      head_hungparty: "جهة غلق الاتصال",
      head_reason: "سبب المكالمة",
      head_listen: "استماع",
      head_download: "تحميل",
      listen_btn: "استماع",
      hide_audio_btn: "إغلاق",
      download_btn: "تحميل",
      calltype_incoming: "واردة",
      calltype_outgoing: "صادرة",
      calltype_internal: "داخلية",
      calltype_dial: "اتصال",
      ANSWERED: "مستلمة",
      UNANSWERED: "غير مستلمة",
      DROP: "فائتة",
      head_sa: "سرعة الرد",
      head_wait: "مدة الانتظار",
    },
    total_performance_report: {
      title: "أداء المجموعات العام",
      head_skill: "المجموعة",
      head_total: "العدد الكلي",
      head_playback: "الترحيب & الرد الآلي",
      head_offered: "في المجموعة",
      head_success: "الناجحة",
      head_success_rate: "نسبة النجاح",
      head_failed: "الفاشلة",
      head_failed_rate: "نسبة الفشل",
    },
    performance_period_report: {
      title: "الأداء خلال الفترة",
      head_period: "الفترة",
      head_offered: "واردة",
      head_answered: "مجابة",
      head_abandoned: "فائتة",
      head_answered_rate: "نسبة المجابة",
      head_service_level: "مستوى الخدمة",
      head_average_talk_time: "متوسط مدة التحدث",
      head_average_hold_time: "متوسط مدة الانتظار",
      head_average_handle_time: "متوسط مدة المعالجة",
      head_hold_count: "عدد مرات الانتظار",
      summary: "الملخص",
    },
    agent_performance_report: {
      agents_count:
        "{n} موظف | موظف واحدة | موظفان | {n} موظفين | {n} موظف | {n} موظف",
      title: "الأداء العام للموظفين",
      head_agent: "الموظف",
      head_name: "الاسم",
      head_received_calls: "المكالمات المستلمة",
      head_answered_calls: "المكالمات المردود عليها",
      head_answered_rate: "نسبة المردود عليها",
      head_abandoned_calls: "الفائتة",
      head_avg_duration: "متوسط مدة التحدث",
      head_min_duration: "أقل مدة للتحدث",
      head_max_duration: "أكبر مدة للتحدث",
    },
    agent_calls_report: {
      calls_count:
        "{n} مكالمة | مكالمة واحدة | مكالمتان | {n} مكالمات | {n} مكالمة | {n} مكالمة",
      title: "سجل المكالمات",
      head_date: "التاريخ",
      head_src: "الهاتف",
      head_call_type: "نوع المكالمة",
      head_duration: "المدة",
      head_reason: "السبب",
      calltype_incoming: "واردة",
      calltype_outgoing: "صادرة",
      calltype_internal: "داخلية",
      calltype_dial: "اتصال",
      no_calls: "لا يوجد مكالمات",
    },
    agent_status_report: {
      my_statuses: "حالاتي",
      status_count:
        "{n} حالة | حالة واحدة | حالتان | {n} حالات | {n} حالة | {n} حالة",
      title: "احصائيات حالات الموظف",
      online_time: "فترة الاتصال",
      busy_time: "فترة الانشغال",
      rest_time: "فترة الراحة",
      available_time: "فترة التوفر",
      head_time: "الوقت",
      head_date: "التاريخ",
      head_action: "الحالة",
      head_duration: "المدة",
      status_online: "متصل",
      status_busy: "غير مستعد",
      status_rest: "راحة",
      status_offline: "غير متصل",
      no_statuses: "لا يوجد حالات",
    },
    system_inbound_report: {
      title: "تقرير النظام الوارد",
      calls_count:
        "{n} مكالمة | مكالمة واحدة | مكالمتان | {n} مكالمات | {n} مكالمة | {n} مكالمة",
      date: "التاريخ",
      head_Inbound: "المكالمات الواردة",
      head_Successful: "المكالمات الناجحة ",
      head_Rate: "الرد الصوتي التفاعلي ومعدل النجاح % ",
      head_LostCall: "المكالمات المفقودة",
    },
    leaving_detail_report: {
      leaving_count:
        "{n} مغادرة |  واحدة | مغادرات | {n} مغادرتين | {n} مغادرة | {n} مغادرة",
      title: "تقرير مغادرة الموظف بالتفصيل",
      head_ID: "الموظف",
      head_Name: "الاسم",
      head_LeavingTime: " وقت المغادرة ",
      head_LeavingDuration: "مدة المغادرة",
      head_StartTime: "بداية المغادرة",
      head_EndTime: "نهاية المغادرة",
      head_ActualDuration: "مدة المغادرة الفعلية",
      head_ExtraDuration: "مدة المغادرة الإضافية",
    },
    leaving_summary_report: {
      title: "ملخص تقرير مغادرة الوكيل",
      head_ID: "الموظف",
      head_Name: "الاسم",
      head_LeavingNumber: "عدد طلبات المغادرة ",
      head_LeavingDuration: " مدة المغادرة",
      head_ExtraDuration: "مدة المغادرة الإضافية",
      head_ExtraNumberLeaving: "عدد المغادرة الإضافية",
    },
    login_detail_report: {
      title: "تقرير تسجيل الدخول/الخروج بالتفصيل",
      log: "تسجيل",
      head_ID: "الموظف",
      head_Name: "الاسم",
      head_Login: "تسجيل الدخول ",
      head_Logout: "تسجيل خروج",
      head_Staffed: "المدة الزمنية",
    },
    login_summary_report: {
      title: "تقرير تسجيل الدخول/الخروج في ملخص",
      head_ID: "الموظف",
      head_Name: "الاسم",
      head_Login: "تسجيل الدخول ",
      head_Logout: "تسجيل خروج",
      head_Staffed: "المدة الزمنية",
    },
    status_detail_report: {
      title: "حالة الموظف بالتفصيل",
      head_ID: "الموظف",
      head_Name: "الاسم",
      head_Status: "الحالة",
      head_BeginTime: "وقت البدء",
      head_EndTime: "وقت انتهاء ",
      head_Duration: "المدة",
    },
    status_summary_report: {
      title: "حالة الموظف في ملخص",
      head_Name: "الاسم",
      head_online_periods: "متصل | فترات",
      head_offline_periods: "غير متصل | فترات",
      head_rest_periods: "راحة | فترات",
      head_not_ready_periods: "غير مستعد | فترات",
      head_online_duration: "مدة الاتصال",
      head_offline_duration: "مدة الغير متصل",
      head_rest_duration: "مدة الراحة",
      head_not_ready_duration: "مدة الغير مستعد",
    },
    agent_kpi_report: {
      title: "مؤشرات الأداء الرئيسية للموظفين",
      head_day: "Day",
      head_offered: "OFF",
      head_answered: "ANS",
      head_abandoned: "ABD",
      head_average_handle_time: "AHT",
      head_utilization: "Utilization",
      head_occupancy: "Occupancy",
      head_agent_behavior: "Agent Behavior",
      head_fcr: "FCR",
      head_very_satisfied: "Very Satisfied",
      head_satisfied: "Satisfied",
      head_neutral: "Neutral",
      head_dissatisfied: "Dissatisfied",
      head_very_dissatisfied: "Very Dissatisfied",
      head_yes: "Yes",
      head_no: "No",
    },

    csat_report: {
      title: "تقرير الرضا على العميل بالرسوم البيانية",
      all_entered_surveys: "جميع الاستبيانات المدخلة",
      completed_surveys: "الاستبيانات المكتملة",
      uncompleted_surveys: "الاستبيانات غير المكتملة",
      very_dissatisfied: "غير راضي",
      dissatisfied: "غير راضي",
      neutral: "متوسط",
      satisfied: "راضي",
      very_satisfied: "راضي جدا",
      fcr_question: "هل تم تنفيذ او حل طلبكم خلال تواصلكم الاخير؟",
      agent_performance_question:
        "كيف تقيم مدى رضاك عن اداء الموظف الذي قام بخدمتكم؟",
      customer_effort_question:
        "كيف تقييم مدى السهولة التي وفرتها (قو) في التعامل مع طلبكم؟",
      csat_question:
        "كيف تقييم مدى رضاكم عن تواصلكم الاخير مع مركز قو لخدمة العملاء؟",
      agent_name: "الموظف",
      yes: "نعم",
      no: "لا",
      month: "الشهر",
      neutural: "متوسط",
      promoters: "المروّجون",
      passives: "المحايدون",
      detractors: "المنتقدون",
      nps_question: "سؤال NPS",
      report_variant: "نوع التقرير",
      per_agent: "حسب الموظف",
      per_month: "حسب الشهر",
      per_call: "حسب المكالمة",
      show_tables: "عرض الجداول",
      show_charts: "عرض الرسوم البيانية",
    },
    csat_table_report: {
      title: "تقرير جداول الرضا",
    },
    repeated_calls_report: {
      title: "تقرير المكالمات المكررة",
      head_month: "الشهر",
      head_repeated_calls: "المكالمات المكررة",
    },
    call_reasons_report: {
      title: "تقرير أسباب المكالمات",
      complaint: "شكوى",
      request: "طلب",
      inquiry: "استفسار",
      not_selected: "غير محدد",
      go_to_table: "الذهاب إلى جدول أسباب المكالمات",
      export_tooltip: "انقر للتصدير",
      no_data: "لا توجد بيانات",
    },
    ivr_report: {
      title: "تقرير الرد الآلي",
      no_data: "لا توجد بيانات للرد الآلي",
    },
    ivr_campaign_summary_report: {
      title: "ملخص ومكالمات حملة الرد الآلي",
      summary_title: "الملخص",
      calls_title: "المكالمات",
      head_total_calls: "إجمالي المكالمات",
      head_answered: "تم الرد",
      head_unanswered: "بدون رد",
      head_success_rate: "نسبة النجاح",
      head_campaign: "الحملة",
      head_customer: "العميل",
      head_disposition: "النتيجة",
      head_retry: "المحاولات",
      head_invoice: "الفاتورة",
      head_date: "التاريخ",
      no_data: "لا توجد بيانات للحملة في النطاق المحدد",
      dispositions: {
        answered: "تم الرد",
        busy: "مشغول",
        no_answer: "بدون رد",
        canceled: "ملغاة",
        failed: "فشلت",
      },
    },
    call_analysis: {
      back: "رجوع",
      title: "تحليل المكالمة",
      action_tooltip: "عرض تحليل المكالمة",
      not_found: "لا يوجد تحليل متاح لهذه المكالمة.",
      loading: "جارٍ تحميل التحليل...",
      head_call_id: "معرّف المكالمة",
      head_number: "الرقم",
      head_agent: "الموظف",
      head_date: "التاريخ",
      load_recording: "تحميل التسجيل",
      qa_score: "درجة الجودة",
      qa_checks_passed: "المعايير المجتازة",
      qa_required_failure: "فشل معيار إلزامي",
      qa_no_failures: "لا توجد إخفاقات إلزامية",
      qa_section_title: "تقييم الجودة",
      required: "إلزامي",
      optional: "اختياري",
      confidence: "الثقة",
      evidence: "الدليل",
      reasoning: "التفسير",
      customer_sentiment: "مشاعر العميل",
      agent_sentiment: "مشاعر الموظف",
      magnitude: "الشدّة",
      score: "الدرجة",
      positive: "إيجابي",
      neutral: "محايد",
      negative: "سلبي",
      timeline_title: "الجدول الزمني للمشاعر",
      summary_section_title: "الملخص",
      transcript_section_title: "النص",
      no_transcript: "لا يوجد نص متاح لهذه المكالمة.",
      role_agent: "الموظف",
      role_customer: "العميل"
    },
    voice_agent_cdr: {
      title: "سجل مكالمات الوكيل الصوتي",
      head_call_id: "معرّف المكالمة",
      head_caller: "المتصل",
      head_dialed: "الرقم المطلوب",
      head_duration: "المدة",
      head_started: "وقت البدء",
      head_ended: "وقت الانتهاء",
      head_forwarded: "محوّلة",
      view_details: "عرض التفاصيل",
      forwarded_yes: "نعم",
      forwarded_no: "لا",
      stat_total_calls: "إجمالي المكالمات",
      stat_avg_duration: "متوسط المدة",
      details_title: "تفاصيل المكالمة الصوتية",
      meta_room: "الغرفة",
      meta_recording: "التسجيل",
      transcript_title: "النص",
      no_transcript: "لا يوجد نص متاح لهذه المكالمة.",
      role_assistant: "الوكيل الذكي",
      role_user: "المتصل",
      no_data: "لا توجد تفاصيل متاحة.",
      loading: "جارٍ تحميل التفاصيل...",
      back: "رجوع",
      not_found: "لا توجد تفاصيل متاحة لهذه المكالمة.",
      load_recording: "تحميل التسجيل",
      recording_unavailable: "التسجيل غير متاح",
      summary_title: "الملخص",
      tags_title: "الوسوم",
      head_tags: "الوسوم"
    },
    ai_chat_transcript: {
      title: "محادثات الوكيل الذكي",
      head_conversation_id: "معرّف المحادثة",
      head_customer: "العميل",
      head_channel: "القناة",
      head_outcome: "النتيجة",
      head_started: "وقت البدء",
      head_ended: "وقت الانتهاء",
      view_transcript: "عرض المحادثة",
      stat_total_chats: "إجمالي المحادثات",
      stat_avg_duration: "متوسط المدة",
      stat_escalation_rate: "معدل التصعيد",
      details_title: "تفاصيل المحادثة",
      back: "رجوع",
      tags_title: "الوسوم",
      meta_customer: "العميل",
      meta_channel: "القناة",
      meta_agent: "الموظف",
      meta_outcome: "النتيجة",
      meta_started: "وقت البدء",
      meta_ended: "وقت الانتهاء",
      summary_title: "الملخص",
      transcript_title: "النص",
      no_transcript: "لا توجد رسائل في هذه المحادثة.",
      no_data: "لا توجد تفاصيل متاحة للمحادثة.",
      loading: "جارٍ تحميل المحادثة...",
      role_customer: "العميل",
      role_assistant: "المساعد الذكي",
      role_agent: "الموظف",
      channels: {
        1: "رسالة نصية",
        2: "بريد إلكتروني",
        3: "واتساب",
        4: "تيليجرام",
        5: "فيسبوك",
        6: "إنستغرام",
        7: "تويتر / إكس",
        8: "محادثة الويب",
        default: "قناة"
      },
      outcomes: {
        abandoned: "مهجورة",
        escalated: "مُصعّدة",
        resolved: "محلولة",
        completed: "مكتملة",
        closed: "مغلقة"
      }
    },
    pagination: {
      records_per_page: "السجلات في الصفحة",
      rows_per_page: "الصفوف في الصفحة",
      showing: "عرض",
      of: "من",
      page: "صفحة",
      records: "سجل",
      first_page: "الصفحة الأولى",
      previous_page: "الصفحة السابقة",
      next_page: "الصفحة التالية",
      last_page: "الصفحة الأخيرة",
      jump_to: "انتقل إلى صفحة",
      go: "اذهب",
    },
    loading: {
      default: "جاري تحميل بيانات التقرير...",
      initial: "جاري تحميل البيانات الأولية...",
      processing: "جاري المعالجة...",
      general: "جاري التحميل..."
    },
    empty: {
      title: "لا توجد بيانات",
      description: "لا توجد بيانات تطابق المرشحات الحالية. حاول تعديل معايير البحث أو تحديث البيانات.",
      refresh: "تحديث البيانات"
    },
    error: {
      title: "خطأ في تحميل التقرير",
      retry: "إعادة المحاولة",
      dismiss: "إغلاق",
      close: "إغلاق"
    },
  },
};
